module.exports = __webpack_public_path__ + "img/Nabiha.8c48892f.jpg";